// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"335d0021","829":"11d15f57","919":"2f92ce6a"}[chunkId] + ".chunk.js";
};